import { useRef, useState, useEffect } from 'react';

/**
 * useReveal — triggers a fade-up animation when an element
 * enters the viewport using IntersectionObserver.
 *
 * Usage:
 *   const { ref, visible } = useReveal();
 *   <div ref={ref} style={{ opacity: visible ? 1 : 0 }}>...</div>
 */
export function useReveal(threshold = 0.12) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return { ref, visible };
}
